import axios from "axios";
import { eApplicationPermission } from "../enums";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";

/**
 * DTO containing the authenticated user's properties.
 */
export interface UserPropertiesDto {
  /** Numeric identifier of the authenticated user. */
  userId: number;
  /** Whether the authenticated user has administrative access. */
  isAdmin: boolean;
  /** Application permissions assigned to the authenticated user. */
  applicationPermissions: eApplicationPermission[];
}

export type IMeReturn = IAxiosReturn<UserPropertiesDto>;

/**
 * Gets information about the current user.
 *
 * @param backEndUrl - The backend API base URL for making HTTP requests
 * @returns A promise resolving to `IMeReturn` with current user's ID, admin flag and permissions.
 */
export const getMe = async (backEndUrl: string): Promise<IMeReturn> => {
  const url = `${backEndUrl}Users/Me`;
  // Get data
  try {
    const response: { data: UserPropertiesDto } = await axios.get(url);
    // Return successful result
    return {
      success: true,
      data: {
        userId: response.data.userId,
        isAdmin: response.data.isAdmin,
        applicationPermissions: response.data.applicationPermissions,
      },
    };
  } catch (error: unknown) {
    return processAxiosError("Load me failed", error);
  }
};
